var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAudio(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.68,6.39,19.32,6,17.46,7.9l.35.36a5.25,5.25,0,0,1,0,7.48l-.37.36L19.28,18l.36-.35a7.89,7.89,0,0,0,0-11.22Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.74,2.86H11a2.51,2.51,0,0,0-1.74.72L6.38,6.5H4.46A2.47,2.47,0,0,0,2,9V15A2.46,2.46,0,0,0,4.46,17.5h1.9l2.93,2.93a2.51,2.51,0,0,0,1.74.72h.71a2.46,2.46,0,0,0,2.46-2.46V5.32A2.46,2.46,0,0,0,11.74,2.86Zm-.69,15.79L8.12,15.72A2.47,2.47,0,0,0,6.38,15L4.49,15l0-6H6.38a2.45,2.45,0,0,0,1.74-.72L11,5.36h.68l0,13.28Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudio);
export default __webpack_public_path__ + "static/media/audio.7272b81a88b6f56b9221962319ca2128.svg";
export { ForwardRef as ReactComponent };